import React from 'react'
import styled from 'styled-components';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GithubIcon from '@mui/icons-material/GitHub';
import Particle from '../Components/Particle';

const HomePage=()=> {
    return (
        <HomePageStyled>
            {/* <div className="particle-con">
                <Particle />
            </div> */}
            <div className="typography">
                <h1 >
                    Hello, my name is
                    <span> Sultan Parvez</span>
                </h1>
                <p >
                    Currently pursuing an MSc in Quantum Information Science at the University of Copenhagen,
                    with a strong interest in quantum computing and quantum algorithms. I hold a BSc in Computer Science
                    and Engineering, where my thesis explored reinforcement learning in finance. I am eager to deepen
                    my expertise and contribute to research at the intersection of quantum technologies and advanced computation.
                </p>
                <div className="icons">
                    <a target="_blank" href="https://www.linkedin.com/in/sultanparvez/" className="icon i-facebook">
                        <LinkedInIcon />
                    </a>
                    <a target="_blank" href="https://github.com/sultanparvez" className="icon i-github">
                        <GithubIcon />
                    </a>

                </div>
            </div>
        </HomePageStyled>
    )
}

const HomePageStyled = styled.header`

    width: 100%;
    height: 100vh;
    position: relative;

    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;

        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:hover{
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }

            .i-youtube{
                &:hover{
                    border: 2px solid red;
                    color: red;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid #5F4687;
                    color: #5F4687;
                }
            }
        }
    }
`;

export default HomePage;
